import { render, staticRenderFns } from "./AssuranceGoldPrintHtml.vue?vue&type=template&id=3571c216&scoped=true&"
import script from "./AssuranceGoldPrintHtml.vue?vue&type=script&lang=js&"
export * from "./AssuranceGoldPrintHtml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3571c216",
  null
  
)

export default component.exports